import {
  ADD_FOLDER,
  ADD_MDM_VIEW,
  ADD_MODULE,
  ADD_NEW_ROW_IN_TABLE,
  BULK_UPDATE_CHECKS_SET,
  BULK_UPDATE_CHECKS_UNSET,
  DELETE_FIELD,
  DELETE_FOLDER,
  DELETE_IMPORT_ROW,
  DELETE_MDM_VIEW,
  DELETE_MODULE,
  DELETE_TABLE,
  GET_PERMISSIONS_BY_OBJECT,
  GET_TABLE_DATA,
  GET_TODO_USER_LIST,
  HIDE_CREATE_RECORD_MODAL,
  HIDE_DATA_MANAGEMENT_MODAL,
  HIDE_FIELD_MODAL,
  HIDE_FOLDER_MODAL,
  HIDE_IMPORT_MODAL,
  HIDE_IMPORT_TABLE_VIEW_MODAL,
  HIDE_MODULE_MODAL,
  HIDE_PERMISSIONS_MODAL,
  HIDE_TODO_LIST_MODAL,
  HIDE_VIEW_RECORD_MODAL,
  INSERT_ITEM_IN_SCHEMA,
  MDM_VIEW_MARK_DEFAULT,
  PROCESS_PROGRESS_BAR,
  SELECT_MDM_VIEW,
  SET_LOOKUP_VALUES,
  SET_BUILDER_LOADING,
  SET_CURRENT_FOLDER,
  SET_EDIT_FILTER_MODAL_LOADING,
  SET_EDIT_MODAL_LOADING,
  SET_FIELD_DATA,
  SET_FIELD_DATA_LOADING,
  SET_FIELDS,
  SET_FOLDER_DATA,
  SET_FOLDER_DATA_LOADING,
  SET_FOLDER_DATA_PERMISSIONS,
  SET_FOLDER_LIST,
  SET_FOLDER_LIST_LOADING,
  SET_FOLDERS_DATA,
  SET_MODAL_FIELDS,
  SET_MODAL_LOADING,
  SET_MODULE_DATA,
  SET_MODULE_DATA_LOADING,
  SET_MODULE_DATA_PERMISSIONS,
  SET_MODULE_LIST,
  SET_MODULE_LIST_LOADING,
  SET_MODULE_MODAL_LOADING,
  SET_PAGEDDATA_LOOKUP_VALUES_LOADING,
  SET_POWER_APPS_ENTITY,
  SET_POWER_BI_REPORT_ENTITY,
  SET_RECYCLE_BIN_DATA,
  SET_RECYCLE_BIN_LOADING,
  SET_TABLE_DATA,
  SET_TABLE_DATA_LOADING,
  SET_TABLE_DATA_PERMISSIONS,
  SET_TABLE_FIELDS,
  SET_TABLE_ROW,
  SET_TABLE_SCHEMA,
  SET_TABLE_TOGGLE_COLUMNS,
  SET_TABLE_VIEW_LOADING,
  SET_TABLE_VIEW_SCHEMA,
  SET_TABLES,
  SET_VIEW_RECORD_MODAL_DATA,
  SHOW_CREATE_FILTER_MODAL,
  SHOW_CREATE_RECORD_MODAL,
  SHOW_DATA_MANAGEMENT_MODAL,
  SHOW_FIELD_MODAL,
  SHOW_FOLDER_MODAL,
  SHOW_IMPORT_MODAL,
  SHOW_IMPORT_TABLE_VIEW_MODAL,
  SHOW_MODULE_MODAL,
  SHOW_PERMISSIONS_MODAL,
  SHOW_TODO_LIST_MODAL,
  SHOW_VIEW_RECORD_MODAL,
  TOGGLE_DATA_MANAGEMENT_MODAL,
  TOGGLE_TABLE_VIEW_MODAL_LOADING,
  TOGGLE_TODO_LIST_TABLE_LOADING,
  TOGGLE_VIEW_RECORD_MODAL,
  UPDATE_FIELD,
  UPDATE_FIELD_POSITION,
  UPDATE_FOLDER,
  UPDATE_FOLDER_TABLE,
  UPDATE_IMPORT_LOOKUP_OPTION,
  UPDATE_IMPORT_REVIEW,
  UPDATE_IMPORT_TABLE_VIEW_MODAL_ITEMS,
  UPDATE_MDM_VIEW,
  UPDATE_MODULE,
  UPDATE_PAGINATION,
  UPDATE_PAGINATION_PARAMS,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_ITEMS,
  SET_ORCHESTRATION,
  SET_ORCHESTRATION_LOADING,
  UPDATE_TODO_LIST_CONFIG,
  OPEN_CONTEXT_MENU,
  CLOSE_CONTEXT_MENU,
  RESET_TABLE_DATA,
  UPDATE_FUZZY_LIST,
  CREATE_FUZZY_CONFIG,
  REMOVE_ELEMENT_FROM_FUZZY_LIST,
  ADD_KEYS_FOR_FUZZY_CONFIG_ITEMS,
  REMOVE_CONFIG_IF_FUZZY_DID_NOT_SELECTED,
  TRANSFORM_FUZZY_CONFIG,
  RESET_DEFAULT_OPTIONS,
  FIELD_OPTIONS,
  SET_DEFAULT_LOOKUP_VALUES,
  ADD_SELECTED_VALUE_TO_DEFAULT_FIELDS,
  ADD_MULTISELECT_REFS_TO_STORE,
  UPDATE_CALCULATIONS,
  UPDATE_TABLE_FIELD_IS_CALCULATED_STATE,
  SET_FIELD_ITEM_CALCULATION_LOADING_STATE,
  UPDATE_LOOKUP_OPTION,
  SET_UPLOAD_HISTORY_LOADING,
  SET_UPLOAD_HISTORY_DATA,
  UPDATE_UPLOAD_HISTORY_PAGINATION,
  UPDATE_FULL_UPLOAD_DATA,
} from './mutation-types';
import {axiosClient} from '../../../core/services/http.service';
import eventBus, {
  ON_ASSIGN_GROUPS_TO_FIELD_PERMISSION,
  ON_ASSIGN_USERS_TO_FIELD_PERMISSION,
} from '../../../core/services/event-bus';
import moment from 'moment';
import store from '../../../store/index';
import Vue from 'vue';
import {SYSTEM_MODULE_MAPPING} from './state';
import {v4 as uuidv4} from 'uuid';
import {getDataTypeJson} from '@/core/utils/getDataTypeJson';
import {isGuid} from '@/core/utils/isGuid';

/**
 *
 * @param { function } commit
 * @param moduleUuid
 * @param { string } data
 */
export async function getFolders({commit}, moduleUuid) {
  commit(SET_FOLDER_LIST_LOADING, true);
  const {success, body} = await axiosClient.get(`/api/module/${moduleUuid}/folders`); //TODO GET FOLDER BY MODULE

  commit(SET_FOLDER_LIST_LOADING, false);
  if (success) {
    commit(SET_FOLDER_LIST, body);
  }
}

/**
 *
 * @param { function } commit
 * @param { string } data
 */
export async function getModules({commit}) {
  commit(SET_MODULE_LIST_LOADING, true);
  const {success, body} = await axiosClient.get('/api/module');
  commit(SET_MODULE_LIST_LOADING, false);
  if (success) {
    commit(SET_MODULE_LIST, body.map(m => {
      let {weight, path, uuid, name, children} = SYSTEM_MODULE_MAPPING[m.moduleType] || {};

      if (m.isSystem) {
        if (!name) {
          for (const key in SYSTEM_MODULE_MAPPING) {
            const obj = SYSTEM_MODULE_MAPPING[key];

            if (obj.children && obj.children.length) {
              const subModule = obj.children.find(child => child.type === m.moduleType);
              if (subModule) {
                weight = subModule.weight;
                path = subModule.path;
                uuid = subModule.uuid;
                name = subModule.name;
                children = subModule.children;
                break;
              }
            }
          }
        }
        m = {
          ...m,
          isSystem: true,
          menuItemName: name || uuid || m.moduleUuid,
          path: `${path}?module_uuid=${m.moduleGuid}`,
          text: m.moduleName,
          weight: weight,
          name: name || uuid || m.moduleUuid,
          uuid: uuid || m.moduleGuid,
          permission: 'write',
          icon: ['fas', m.moduleIcon || 'square'],
          children: children || [],
        };
      }

      return m;
    }));

  }
}

export async function getAllFolder({commit}) {
  commit(SET_FOLDER_DATA_LOADING, true);
  const {success, body} = await axiosClient.get('/api/folder');
  commit(SET_FOLDER_DATA_LOADING, false);
  if (success) {
    commit(SET_FOLDERS_DATA, body);
  }
}

export async function getModuleData({commit}, uuid) {
  commit(SET_MODULE_DATA_LOADING, true);
  const {success, body} = await axiosClient.get(`/api/module/${uuid}`);
  commit(SET_MODULE_DATA_LOADING, false);
  if (success) {
    commit(SET_MODULE_DATA, body);
  }
  return body;
}

export function showFolderModal({commit}, data = null) {
  commit(SHOW_FOLDER_MODAL, {data});
}

export function showModuleModal({commit}, data = null) {
  commit(SHOW_MODULE_MODAL, {data});
}

export function showPermissionsModal({commit}, data = null) {
  commit(SHOW_PERMISSIONS_MODAL, {data});
}

export function hideFolderModal({commit}) {
  commit(HIDE_FOLDER_MODAL);
}

export function hideModuleModal({commit}) {
  commit(HIDE_MODULE_MODAL);
}

export function hidePermissionsModal({commit}) {
  commit(HIDE_PERMISSIONS_MODAL);
}

export async function createFolder({commit}, folder) {
  commit(SET_MODAL_LOADING, true);
  const response = await axiosClient.post('/api/folder', folder);
  commit(SET_MODAL_LOADING, false);
  if (response.success) {
    commit(ADD_FOLDER, {data: response.body});
  }
  return response;
}

export async function createModule({commit}, module) {
  commit(SET_MODULE_MODAL_LOADING, true);
  const response = await axiosClient.post('/api/module', module);
  commit(SET_MODULE_MODAL_LOADING, false);
  if (response.success) {
    commit(ADD_MODULE, {data: response.body});
  }
  return response;
}

export async function updateFolder({commit}, folder) {
  commit(SET_MODAL_LOADING, true);
  const response = await axiosClient.put('/api/folder', folder);
  commit(SET_MODAL_LOADING, false);
  if (response.success) {
    commit(UPDATE_FOLDER, {data: response.body});
  }
  return response;
}

export async function updateModule({commit}, module) {

  commit(SET_MODULE_MODAL_LOADING, true);
  const response = await axiosClient.put('/api/module', module);
  commit(SET_MODULE_MODAL_LOADING, false);
  if (response.success) {
    commit(UPDATE_MODULE, {data: response.body});
  }
  return response;
}

export async function deleteFolder({commit}, folder) {
  const response = await axiosClient.delete(`/api/folder/${folder.folderGuid}`);
  if (response.success) {
    commit(DELETE_FOLDER, folder);
  }
  return response;
}

export async function deleteModule({commit}, module) {
  const response = await axiosClient.delete(`/api/module/${module.moduleGuid}`);
  if (response.success) {
    commit(DELETE_MODULE, module);
  }
  return response;
}

export async function deleteTable({commit}, table) {
  try {
    const response = await axiosClient.delete(`/api/entity/${table.entityGuid}`);
    commit(DELETE_TABLE, table);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getTableSchema({dispatch, commit, state}, tableUuid) {
  const {success, body} = await axiosClient.get(`/api/entity/${tableUuid}`);
  const fields = await axiosClient.get(`api/entity/${tableUuid}/fields`);

  const data = body;
  data.fields = fields.body
    .filter((field) => !field.isInternal)
    .map((elem) => {
      elem.dataTypeJSON = typeof elem.dataTypeJSON === 'string'
        ? JSON.parse(elem.dataTypeJSON)
        : elem.dataTypeJSON;

      if(elem.dataTypeName === 'lookup') {
        state.table.schema.fields.forEach(sEl => {
          if(sEl.fieldGuid === elem.fieldGuid && sEl.data && sEl.data.options.length) {
            elem.data = sEl.data;
          }
        });
      }

      if(elem.dataTypeName === 'lookup' && elem.dataTypeJSON.FuzzyMatchConfig) {
        elem.dataTypeJSON.FuzzyMatchConfig = {
          ...elem.dataTypeJSON.FuzzyMatchConfig,
          AutoMatchThreshold: !elem.dataTypeJSON.FuzzyMatchConfig.AutoMatchThreshold
            ? null
            : elem.dataTypeJSON.FuzzyMatchConfig.AutoMatchThreshold * 100,
          MatchThreshold: elem.dataTypeJSON.FuzzyMatchConfig.MatchThreshold * 100,
          FieldConfigs: elem.dataTypeJSON.FuzzyMatchConfig.FieldConfigs.length
            ? elem.dataTypeJSON.FuzzyMatchConfig.FieldConfigs.map(config => ({
              ...config,
              MatchThreshold: config.MatchThreshold * 100,
              key: uuidv4(),
            }))
            : [],
        };
      }
      return elem;
    });

  if (success) {
    const {entityConfigJSON, toDoListConfigJSON, validationRulesJson, ...tableData} = data;
    dispatch('designer/getMainDesignerData', tableData.addEditRowSectionsJSON, {root: true});
    dispatch('designer/getAdditionalInfoAboutDesignerFields', data.fields, {root: true});
    commit(SET_TABLE_SCHEMA, {
      ...tableData,
      entityConfig: entityConfigJSON !== null ? JSON.parse(entityConfigJSON) : entityConfigJSON,
      toDoListConfig: toDoListConfigJSON === null ? null : JSON.parse(toDoListConfigJSON),
      validationRules: validationRulesJson !== null ? JSON.parse(validationRulesJson) : validationRulesJson,
    });
  }
}

export function updateTodoListConfig({commit}, payload) {
  commit(UPDATE_TODO_LIST_CONFIG, payload);
}

export async function updateFields({commit}, fields) {
  try {
    const {success, body} = await axiosClient.put('/api/field/upsert-multiple', fields);
    const res = body.item1.map(el => {
      const JSONConfig = JSON.parse(el.dataTypeJSON);
      if(el.dataTypeName === 'lookup' && !!JSONConfig.FuzzyMatchConfig ) {
        const fuzzy = {
          ...JSONConfig.FuzzyMatchConfig,
          AutoMatchThreshold: !JSONConfig.FuzzyMatchConfig.AutoMatchThreshold
            ? null
            :  JSONConfig.FuzzyMatchConfig.AutoMatchThreshold * 100,
          MatchThreshold: JSONConfig.FuzzyMatchConfig.MatchThreshold * 100,
          FieldConfigs: JSONConfig.FuzzyMatchConfig.FieldConfigs && JSONConfig.FuzzyMatchConfig.FieldConfigs.length
            ? JSONConfig.FuzzyMatchConfig.FieldConfigs.map(config => ({
              ...config,
              MatchThreshold: config.MatchThreshold * 100,
              key: uuidv4(),
            }))
            : [],
        };
        el.dataTypeJSON = JSON.stringify({
          ...JSONConfig,
          FuzzyMatchConfig: fuzzy,
        });
        return el;
      }
      return el;
    });

    // Update fields to remove isNew property once the field is saved
    res.forEach(el => {
      commit(UPDATE_FIELD, el);
    });

    body.item1 = res;
    if (!success) {
      throw {message: body.ErrorMessage};
    }

    return body;
  } catch (error) {
    throw error;
  }
}

export async function deleteField({commit}, field) {
  try {
    const response = await axiosClient.delete(`/api/field/${field.fieldGuid}`);
    if(response.success){
      commit(DELETE_FIELD, field);
    } 

    return response;
  } catch (error) {
    throw error;
  }
}

export async function deletePostedStatusField({commit}, {field, entityGuid}) {
  try {
    const response = await axiosClient.delete(`/api/Entity/${entityGuid}/deleteEntityPostedStatusField`);
    if(!!response.success) {
      commit(DELETE_FIELD, field);
    }
    
    return response;
  } catch (error) {
    throw error;
  }
}

export function updateFieldPosition({commit}, {field, position}) {
  commit(UPDATE_FIELD_POSITION, {field, position});
}

export function showFieldBuilderModal({commit}, field) {
  commit(SHOW_FIELD_MODAL, field);
}

export function hideFieldBuilderModal({commit}, field) {
  commit(HIDE_FIELD_MODAL);
}

export async function addItem({commit}, params) {
  commit(INSERT_ITEM_IN_SCHEMA, params);
}


export async function deleteTableRecord({commit}, params) {
  const response = await axiosClient.delete(`/api/entity/${params.entityId}/data/${params.recordId}`);
  return response;
}

export async function deleteTableRecords({commit}, params) {
  commit(SET_TABLE_VIEW_LOADING, true);
  const response = await axiosClient.delete(`/api/entity/${params.entityId}/data`, {data: params.data});
  commit(SET_TABLE_VIEW_LOADING, false);
  return response;
}

export async function bulkDeleteTableRecords({commit}, params) {
  commit(SET_TABLE_VIEW_LOADING, true);
  const response = await axiosClient.post(`api/entity/${params.entityId}/bulkdelete`, {filters: params.filters});
  commit(SET_TABLE_VIEW_LOADING, false);
  return response;
}

export async function bulkUpdateTableRecords({commit}, params) {
  commit(SET_TABLE_VIEW_LOADING, true);
  const response = await axiosClient.post(`api/entity/${params.entityId}/bulkupdate`, {
    data: params.data,
    filters: params.filters,
  });
  commit(SET_TABLE_VIEW_LOADING, false);
  return response;
}

export async function exportSchema({commit}, params) {
  window.open(`${VUE_APP_NODE_SERVER_URL}/tables/schema/export-data?uuid=${params.id}&token=${params.token}`);
}

export async function getPopulatedRecord({commit}, params) {
  const result = await axiosClient.get(`/api/entity/${params.entityGuid}/data/${params.recordGuid}/createPrePopulatedRecord/${params.fieldGuid}`);
  return result.body;
}

// export async function getEditModalData({commit}, tableId) {
//   return axiosClient.get(`api/entity/${tableId}/data`);
// }

export async function getSingleRecordData({commit}, params) {
  const {success, body} = await axiosClient.get(`api/entity/${params.tableId}/record/${params.recordGuid}`);
  if (success) return body;
  return {};
}

export async function getTable({dispatch, commit, state, getters, rootState}, params) {
  if (params.isModal) {
    commit(SET_EDIT_MODAL_LOADING, {modalKey: params.modalKey, loading: true});
  } else {
    commit(SET_TABLE_VIEW_LOADING, true);
  }

  let table;
  let tableData;
  let folder;
  let fieldsData;
  let modalFields;
  let modalFieldsData;
  let data = {};

  let selectedView = null;
  if (params.isModal || params.isTodo) {
    modalFields = await axiosClient.get(`api/entity/${params.relationalTableId}/fields`);

    modalFieldsData = await fieldSetter(
      {commit, getters, state, rootState},
      {fields: modalFields.body, table: {}, items: {}});
    data = {
      ...getters.tableSchema,
      ...getters.tableSchema.schema,
      ...getters.tableSchema.pagination,
    };
    if (!params.isTodo) {
      commit(SET_MODAL_FIELDS, {
        modalKey: params.modalKey,
        fields: modalFieldsData ? modalFieldsData.entityFields : [],
      });
    } else {
      data['fields'] = modalFieldsData ? modalFieldsData.entityFields : [];
    }
  } else {
    const tableResult = await axiosClient.get(`api/entity/${params.id}`);
    dispatch('designer/getMainDesignerData', tableResult.body.addEditRowSectionsJSON, {root: true});
    dispatch('designer/getAdditionalInfoAboutDesignerFields', state.table.schema.fields, {root: true});

    if ('body' in tableResult) {
      table = tableResult.body;
      commit(SET_TABLE_DATA, table);
    } else {
      table = tableResult;
    }

    const viewGuid = params.viewGuid;
    delete params.viewGuid;
    let viewJSON = null;
    if (viewGuid) {
      const view = table.views.find(v => v.viewGuid === viewGuid);
      if (view) {
        viewJSON = JSON.parse(view.viewJSON);

        params = {
          ...params,
          ...viewJSON,
        };
      }
    }

    tableData = await axiosClient.post(`api/entity/${params.id}/pageddata`, params);

    if (params.singleRecordGuid) {
      const singleRecordResponse = await axiosClient.get(`api/entity/${params.id}/record/${params.singleRecordGuid}`);
      if (singleRecordResponse.success) {
        tableData = {
          body: {
            ...tableData.body,
            Records: [singleRecordResponse.body],
          },
        };
      }
    }
    folder = await axiosClient.get(`api/folder/${table.folderGuid}`);
    commit(SET_CURRENT_FOLDER, folder.body);

    fieldsData = await fieldSetter(
      {commit, getters, state, rootState},
      {
        fields: state.table.schema.fields,
        table,
        items: tableData.body,
      });

    const selectedFromState = state.table.views.find(v => v.isSelected);
    if (!selectedFromState || params.id !== selectedFromState.entityGuid) {
      selectedView = table.views.find(v => v.isDefault);
    } else {
      selectedView = selectedFromState;
    }

    data = {
      ...table,
      folder: folder.body,
      fields: fieldsData.entityFields,
      data: tableData.body.Records || [],
      total: tableData.body.TotalRecords || 0,
      toggleColumns: viewJSON ? viewJSON.toggleColumns : false,
      primaryColumn: fieldsData.primaryColumn,
      views: table.views,
      entityConfig: typeof table.entityConfigJSON === 'string'
        ? JSON.parse(table.entityConfigJSON)
        : table.entityConfigJSON,
      toDoListConfig: typeof table.toDoListConfigJSON === 'string'
        ? JSON.parse(table.toDoListConfigJSON)
        : table.toDoListConfigJSON,
      validationRules: typeof table.validationRulesJson === 'string'
        ? JSON.parse(table.validationRulesJson)
        : table.validationRulesJson,
    };
  }

  commit(SET_TABLE_VIEW_SCHEMA, {...data, ...{page: params.page}});
  if (params.pageSize) {
    dispatch('changePaginationData', {perPage: params.pageSize});
  }
  if (selectedView) {
    commit(SELECT_MDM_VIEW, selectedView.viewGuid);
  }

  if (params.isModal) {
    commit(SET_EDIT_MODAL_LOADING, {modalKey: params.modalKey, loading: false});
  } else {
    commit(SET_TABLE_VIEW_LOADING, false);
  }
}

export async function getPagedData({state, commit, getters, rootState}, params) {
  commit(SET_TABLE_VIEW_LOADING, true);
  const {success, body} = await axiosClient.post(`api/entity/${params.id}/pageddata`, params);
  if (success) {
    const fieldsData = await fieldSetter(
      {commit, getters, state, rootState},
      {
        fields: state.table.schema.fields,
        table: state.table,
        items: body,
        allField: getters.getAllFields,
      });

    const data = {
      ...state.tableData.data,
      views: state.table.views,
      folder: getters.getCurrentFolder,
      fields: fieldsData.entityFields,
      data: body.Records || [],
      total: body.TotalRecords || 0,
      toggleColumns: state.table.schema.toggleColumns || false,
      primaryColumn: fieldsData.primaryColumn,
      validationRules: typeof state.tableData.data.validationRulesJson === 'string'
        ? JSON.parse(state.tableData.data.validationRulesJson)
        : state.tableData.data.validationRulesJson,
    };

    commit(SET_TABLE_VIEW_SCHEMA, {...data, ...{page: params.page}});
    commit(UPDATE_TABLE_DATA, {data: body.Records});
  }
  commit(SET_TABLE_VIEW_LOADING, false);
  return body;
}

export async function getTableFields({dispatch, commit, state}, tableGuid) {
  const {success, body} = await axiosClient.get(`api/entity/${tableGuid}/fields`);
  if (success) {
    dispatch('designer/getAdditionalInfoAboutDesignerFields', body, {root: true});
    let res = body;
    if(state.table.schema.fields.length) {
      res = body.map(bEl => {
        const item = state.table.schema.fields.find(el => el.fieldGuid === bEl.fieldGuid);
        if(item && item.data) {
          return {...bEl, data: item.data};
        }
        return bEl;
      });
    }
    commit(SET_TABLE_FIELDS, res);
  }
  return body;
}

export async function setCheckedItems({commit}, params) {
  commit(BULK_UPDATE_CHECKS_SET, params);
}

export async function unsetUncheckedItem({commit}, params) {
  commit(BULK_UPDATE_CHECKS_UNSET, params);
}

export async function fieldSetter(
  {rootState, state, commit, getters, dispatch},
  {fields, table, items, allField = {}},
) {
  const fetchedEntities = {}; //store fetched entities id. Avoiding duplicate request for same entity. For example if there are 2 lookup columns on same entity
  const entityFields = [];
  const fieldValueTypes = getters.fieldValueTypes;
  let primaryColumn;
  let data = {};
  let relatedFieldItem;
  !!items.LookupValues && commit(SET_DEFAULT_LOOKUP_VALUES, items.LookupValues);
  for (const fieldItem of fields) {
    const jsonData = getDataTypeJson(fieldItem.dataTypeJSON);
    if (fieldItem.isPrimaryKey) {
      primaryColumn = fieldItem.name;
    }

    if (fieldItem.dataTypeName === fieldValueTypes.parentChildHierarchy) {
      const parentFieldItem = await axiosClient.get(`api/field/${jsonData.FieldToDisplayGuid}`); //get data about parent field
      const parentFieldData = await axiosClient.get(`api/entity/${parentFieldItem.body.entityGuid}/data`); //get records from parent field entity
      const parentEntityFields = await axiosClient.get(`api/Entity/${parentFieldItem.body.entityGuid}/fields`); //get all fields from parent entity
      const parentPrimary = parentEntityFields.body.find((f) => f.isPrimaryKey);
      const parentLevel = parentEntityFields.body.find((f) => f.fieldGuid === jsonData.LevelFieldGuid);

      const hierarchyParent = parentEntityFields.body.find((elem) => {
        const json = JSON.parse(elem.dataTypeJSON);
        return parentFieldItem.body.fieldGuid === json.FieldToDisplayGuid && elem.dataTypeName === fieldValueTypes.parentChildHierarchy;
      });


      fieldItem.data = {
        options: {
          items: parentFieldData.body,
          hierarchyField: {
            display: parentFieldItem.body, //Parent column which is displayed
            level: parentLevel, //Parent Tables level column
            primary: parentPrimary, //Parent Tables primary column,
            parent: hierarchyParent, //Parent of display field. For example if: display: England, parent: Europe
          },
        },
      };
    }

    if (fieldItem.dataTypeName === fieldValueTypes.lookup) {
      let data = [];
      let relatedTableGuid;
      let relatedFieldGuid;
      const key = null;
      const value = null;

      //todo: refactor this code
      if (!Object.keys(allField).length) {
        const lookupData = items.LookupValues?.find(l => l.FieldGuid === fieldItem.fieldGuid);
        if(lookupData) {
          data = lookupData.LookupItems.map(l => ({
            id: l.RecordGuid,
            text: l.Value,
          }));

          relatedFieldGuid = lookupData.RelatedField.FieldGuid;
          relatedTableGuid = lookupData.RelatedField.EntityGuid;
        }
      } else { // Paging Data endpoint logic
        if (items.LookupValues && items.LookupValues.length) {
          const lookupData = items.LookupValues.find(l => l.FieldGuid === fieldItem.fieldGuid);
          data = lookupData.LookupItems.map(l => ({
            id: l.RecordGuid,
            text: l.Value,
          }));

          relatedFieldGuid = lookupData.RelatedField.FieldGuid;
          relatedTableGuid = lookupData.RelatedField.EntityGuid;
        }
      }

      fieldItem.data = {
        options: data,
        lookup: {
          key: key,
          value: value,
        },
      };

      fieldItem.data.options.sort(function (a, b) {
        const aText = a.text && typeof a.text === 'string' ? a.text.toLowerCase() : a.text;
        const bText = b.text && typeof b.text === 'string' ? b.text.toLowerCase() : b.text;
        if (aText === null || aText === '') {
          return 1;
        }
        if (bText === null || bText === '') {
          return -1;
        }
        return aText < bText ? -1 : aText > bText ? 1 : 0;
      });

      if (!fieldItem.isRequired && fieldItem.dataTypeName === fieldValueTypes.lookup) {
        data.unshift({id: null, text: '<EMPTY>'});
      }

      fieldItem.relationalTableId = relatedTableGuid;
      fieldItem.relationalFieldId = relatedFieldGuid;

      fieldItem.config = {
        optionValue: 'id',
        optionLabel: 'text',
        placeholder: 'Select Lookup',
        multiple: false,
        closeOnSelect: true,
      };
    }

    if (fieldItem.dataTypeName === fieldValueTypes.text && jsonData && jsonData.UsePredictiveSearch) {
      const predictiveSearch = {};
      const key = fieldItem.name;

      if (!predictiveSearch[key]) predictiveSearch[key] = [];

      if (Array.isArray(items)) {
        items.forEach(item => {
          if (!predictiveSearch[key].includes(item[key])) predictiveSearch[key].push(item[key]);
        });
      }

      fieldItem.suggestions = {...predictiveSearch};
      fieldItem.frontType = 'search-input';
    }

    if (table && fieldItem.fieldGuid === table.postedStatusMDMFieldGuid) {
      fieldItem.data = {
        options: [
          {value: 'Pending', text: 'Pending'},
          {value: 'Posted', text: 'Posted'},
        ],
      };

      fieldItem.config = {
        optionValue: 'value',
        optionLabel: 'text',
        multiple: false,
        closeOnSelect: true,
      };
    }

    entityFields.push(fieldItem);
  }

  data = {
    entityFields: entityFields,
    primaryColumn: primaryColumn,
  };

  return data;
}

export function addNewRow({commit}, row) {
  commit(ADD_NEW_ROW_IN_TABLE, row);
}

export function setTableRow({commit}, id) {
  const row = {};
  const table = tableList.find(table => table.id === id);
  table.fields.forEach(field => {
    if (field.type === 'checkbox') {
      row[field.name] = false;
    } else if (field.type === 'dropdown') {
      row[field.name] = [
        {value: ''},
      ];
    } else {
      row[field.name] = null;
    }
  });
  commit(SET_TABLE_ROW, row);
}

export function showAddNewRecordModal({commit}, data) {
  commit(SHOW_CREATE_RECORD_MODAL, data);
}

export function deleteImportRow({commit}, index) {
  commit(DELETE_IMPORT_ROW, index);
}

export function showAddNewFilterModal({commit}, filter) {
  commit(SHOW_CREATE_FILTER_MODAL, {...filter});
}

export function hideAddNewRecordModal({commit}, modalKey) {
  commit(HIDE_CREATE_RECORD_MODAL, modalKey);
}

export async function showViewRecordModal({commit}, data) {
  commit(SHOW_VIEW_RECORD_MODAL);

  commit(TOGGLE_VIEW_RECORD_MODAL, true);
  const {success, body} = await axiosClient.get(`/api/entity/${data.entityGuid}/data/history/${data.recordGuid}`);
  if (success) {
    commit(SET_VIEW_RECORD_MODAL_DATA, body);
  }
  commit(TOGGLE_VIEW_RECORD_MODAL, false);
}

export function hideViewRecordModal({commit}) {
  commit(HIDE_VIEW_RECORD_MODAL);
}

export function addRefToStore({commit}, payload) {
  commit(ADD_MULTISELECT_REFS_TO_STORE, payload);
}
export async function addNewRecord({commit, dispatch}, {
  data,
  tableId,
  modalKey = null,
  modalName = '',
  validateOnly = false,
  primaryKey = null,
}) {
  const config = {
    'config':
            {
              'ColumnMappings': [],
              'UploadOperationType': modalName === 'import' ? 0 : 1,
              'UploadErrorHandling': 1,
              'RetrieveOnlyFailedRecords': 1,
              'Lookups': [],
              'UploadAsAtDate': data.UploadAsAtDate || data[0].UploadAsAtDate,
              'ManualUpload': modalName ? false : true,
            },
  };

  if (validateOnly) {
    config.config.ValidationOnly = 1;
  }

  if (modalKey) {
    commit(SET_EDIT_MODAL_LOADING, {modalKey: modalKey, loading: true});
  }

  const dataLength = data.length;
  const readyToChunk = dataLength > 5000;
  const chunkSize = readyToChunk ? dataLength / 10 : dataLength;

  if (readyToChunk) commit(PROCESS_PROGRESS_BAR, {target: dataLength});

  const responseList = [];
  for (let i = 0; i < dataLength; i += chunkSize) {
    const chunkData = data.slice(i, i + chunkSize);
    const params = {
      ...config,
      data: chunkData,
    };

    const response = await axiosClient.post(`/api/entity/${tableId}/data`, params);
    responseList.push(response);

    commit(PROCESS_PROGRESS_BAR, {process: chunkData.length});
  }

  let updatedRecord = {};
  if (!['import'].includes(modalName) && primaryKey) {
    // const recordGuid = data[0][primaryKey];
    if (responseList[0].body.ResultSetTemp && responseList[0].body.ResultSetTemp.length) {
      const recordGuid = responseList[0].body.ResultSetTemp[0].recordGuid;
      const {success, body} = await axiosClient.get(`api/entity/${tableId}/record/${recordGuid}`);
      if (success) updatedRecord = body;
    }
  }

  if (modalKey) {
    commit(SET_EDIT_MODAL_LOADING, {modalKey: modalKey, loading: false});
  }

  let error = null;
  let errors = [];
  const resultSetTemp = [];

  const info = {
    recordsDeleted: 0,
    recordsIgnored: 0,
    recordsInserted: 0,
    recordsRejected: 0,
    recordsUpdated: 0,
    recordsUploaded: 0,
  };

  Object.keys(responseList).forEach(key => {
    if (responseList[key].error) error = responseList[key].error;
    if (responseList[key].errors.length) errors = responseList[key].errors;

    const body = responseList[key].body;
    if (!body.IsError) {
      body.ResultSetTemp.forEach(r => resultSetTemp.push(r));
      Object.keys(info).forEach(key => info[key] += body[key]);
    }
  });

  responseList[0].error = error;
  responseList[0].errors = errors;
  responseList[0].body.resultSetTemp = resultSetTemp;
  responseList[0].body = {...responseList[0].body, ...info};

  return {
    ...responseList[0],
    updatedRecord,
  };
}

export async function updateTableData({commit}, {tableId, pagination}) {
  const {success, body} = await axiosClient.post(`/api/entity/${tableId}/pageddata`, {
    pageSize: pagination.perPage,
    pageNumber: pagination.currentPage,
  });

  pagination.total = body.TotalRecords;

  if (success) {
    commit(UPDATE_TABLE_DATA, {
      data: body.Records,
      pagination,
    });
  }
}

export async function addNewFilter({commit}, {data, tableId}) {
  commit(SET_EDIT_FILTER_MODAL_LOADING, true);
  const response = await axiosClient.post(`/tables/${tableId}/filter`, data);
  commit(SET_EDIT_FILTER_MODAL_LOADING, false);
  return response;
}

export async function deleteFilter({commit}, params) {
  return await axiosClient.delete(`/tables/${params.tableId}/filter`, {params: params});
}

export async function updateTableRecord({commit}, params) {
  commit(SET_EDIT_MODAL_LOADING, true);
  const response = await axiosClient.put(`/tables/schema/${params.tableId}/record`, {params: params.data});
  commit(SET_EDIT_MODAL_LOADING, false);
  return response;
}

export async function addTable({commit}, data) {
  commit(SET_BUILDER_LOADING, true);
  try {
    const {entityConfig, toDoListConfig, validationRules, name, ...tableData} = data;
    const payloadData = {
      ...tableData,
      entityConfigJSON: JSON.stringify({
        ...entityConfig,
        PostedStatusMDMFieldGuid: null,
        PostedPeriodTransactionDateGuid: null,
        PostedPeriodLookupFieldGuid: null,
        EntityType: 'none',
        MidLoadWorkflow: entityConfig.MidLoadWorkflow ? entityConfig.MidLoadWorkflow : null,
      }),
      toDoListConfigJSON: !!toDoListConfig ? JSON.stringify(toDoListConfig) : null,
      validationRulesJson: JSON.stringify(validationRules),
    };
    const response = await axiosClient.post('/api/entity', payloadData);
    if (response && response.success) {
      const {entityConfigJSON, toDoListConfigJSON, validationRulesJson, ...responseData} = response.body;
      const newData = {
        ...responseData,
        entityConfig: entityConfigJSON !== null
          ? JSON.parse(entityConfigJSON)
          : entityConfigJSON,
        toDoListConfig: toDoListConfigJSON !== null
          ? JSON.parse(toDoListConfigJSON)
          : toDoListConfigJSON,
        validationRules: validationRulesJson !== null
          ? JSON.parse(validationRulesJson)
          : validationRulesJson,
      };

      commit(UPDATE_FOLDER_TABLE, {data: newData});
      return newData;
    } else {
      throw new Error(response.body.ErrorMessage);
    }
  } catch (error) {
    throw error;
  } finally {
    commit(SET_BUILDER_LOADING, false);
  }
}

export async function updateTable({commit, rootState}, {data, entityCore = false}) {
  commit(SET_BUILDER_LOADING, true);
  try {
    const {entityConfig, toDoListConfig, validationRules, ...tableData} = data;
    const payloadData = {
      ...tableData,
      addEditRowSectionsJSON: await store.dispatch(
        'designer/saveDesignerTabState',
        {uuid: data.entityGuid, isSubmit: true },
        {root: true},
      ) ,
      entityConfigJSON: JSON.stringify({
        ...entityConfig,
        MidLoadWorkflow: entityConfig.MidLoadWorkflow?.WorkflowDefinitionId ? entityConfig.MidLoadWorkflow : null,
      }),
      toDoListConfigJSON: !!toDoListConfig ? JSON.stringify(toDoListConfig) : null,
      validationRulesJson: JSON.stringify(validationRules),
    };

    let response ;

    if (entityCore) {
      response = await axiosClient.put('/api/entity/upsert-entity-core', payloadData);
    } else {
      response = await axiosClient.put('/api/entity', payloadData);
    }

    if (response && response.success) {
      const {entityConfigJSON, toDoListConfigJSON, validationRulesJson, ...responseData} = response.body;
      const newData = {
        ...responseData,
        entityConfig: entityConfigJSON !== null ? JSON.parse(entityConfigJSON) : entityConfigJSON,
        toDoListConfig: toDoListConfigJSON !== null ? JSON.parse(toDoListConfigJSON) : toDoListConfigJSON,
        validationRules: validationRulesJson !== null ? JSON.parse(validationRulesJson) : validationRulesJson,
      };

      commit(UPDATE_FOLDER_TABLE, {data: newData});
      return newData;
    }
  } catch (error) {
    throw error;
  } finally {
    commit(SET_BUILDER_LOADING, false);
  }
}

export async function savePostedStatusField({commit}, {entityGuid, params}) {
  const data = {
    PostedStatusFieldName: params.postedStatusField.displayName,
  };
  return await axiosClient.post(`/api/Entity/${entityGuid}/setEntityPostedStatusField`, data);
}

export async function getTables({commit}) {
  const response = await axiosClient.get('/api/entity');
  if (response.success) {
    commit(SET_TABLES, {data: response.body});
  }
  return response;
}

export async function getFields({commit}) {
  const response = await axiosClient.get('/api/field');
  const fields = response.body.filter((elem) => !elem.isInternal);

  if (response.success) {
    commit(SET_FIELDS, {data: fields});
  }
  return response;
}

export function changePaginationData({commit}, data) {
  commit(UPDATE_PAGINATION, {data});
}

export async function getFolderData({commit}, uuid) {
  commit(SET_FOLDER_DATA_LOADING, true);
  const {success, body} = await axiosClient.get(`/api/folder/${uuid}`);
  commit(SET_FOLDER_DATA_LOADING, false);
  if (success) {
    commit(SET_FOLDER_DATA, body);
  }
  return body;
}

export async function getTableData({dispatch, commit}, uuid) {
  commit(SET_TABLE_DATA_LOADING, true);
  const {success, body} = await axiosClient.get(`/api/entity/${uuid}`);
  commit(SET_TABLE_DATA_LOADING, false);
  if (success) {
    commit(SET_TABLE_DATA, body);
    dispatch('designer/getMainDesignerData', body.addEditRowSectionsJSON, {root: true});
  }
  return body;
}

export async function getFieldData({commit}, uuid) {
  commit(SET_FIELD_DATA_LOADING, true);
  const {success, body} = await axiosClient.get(`/api/Field/${uuid}`, uuid);
  commit(SET_FIELD_DATA_LOADING, false);
  if (success) {
    commit(SET_FIELD_DATA, body);
  }
  return body;
}

export async function getFieldOptions({commit, state}) {
  const {success, body} = await axiosClient.get('/api/fieldOptions');
  if (success) {
    const {providersAndModels, responseTypes} = body.calculationOptions.aiChatOptions;

    const modelOptions = new Map();

    const calculationProviderOptions = [
      ...new Set(providersAndModels
        .map(item => {
          modelOptions.has(item.providerName)
            ? modelOptions.get(item.providerName).push(item.modelName)
            : modelOptions.set(item.providerName, [item.modelName]);
          return item.providerName;
        }))];

    const calculationResponseTypeOptions = [...new Set(responseTypes.map(item => item.optionText))];
  
    commit(FIELD_OPTIONS, {
      calculationProviderOptions,
      calculationResponseTypeOptions,
      providersAndModels,
      modelOptions,
    });
  }
}

export async function getRecycleBinData({commit}) {
  commit(SET_RECYCLE_BIN_LOADING, true);
  const {success, body} = await axiosClient.get('/recycle-bin');
  let res;
  commit(SET_RECYCLE_BIN_LOADING, false);
  if (success) {
    res = body.map((module) => {
      module.showDetails = false;
      module.folders = module.folders.map((folder) => {
        folder.showDetails = false;
        return folder;
      });
      return module;
    });
    commit(SET_RECYCLE_BIN_DATA, res);
  }
  return res;
}

export async function updateRecycleBin({commit}, data) {
  commit(SET_RECYCLE_BIN_DATA, data);
}

export async function restoreModule({commit}, module) {
  const response = await axiosClient.post('/recycle-bin/module', module);
  if (response.success && !module.restrictFetch) {
    await getRecycleBinData({commit});
  }
  return response;
}

export async function restoreFolder({commit}, folder) {
  const response = await axiosClient.post('/recycle-bin/folder', folder);
  if (response.success && !folder.restrictFetch) {
    await getRecycleBinData({commit});
  }
  return response;
}

export async function restoreTable({commit}, table) {
  const response = await axiosClient.post('/recycle-bin/table', table);
  if (response.success && !table.restrictFetch) {
    await getRecycleBinData({commit});
  }
  return response;
}

export async function getTableRelatedColumnOptions({commit}, params) {
  const response = await axiosClient.get('/tables/schema/table-filter-options', {params});
  // TODO handle errors properly
  return response.body;
}

export async function getInputRelatedColumnOptions({commit}, params) {
  const response = await axiosClient.get('/tables/schema/input-filter-options', {params});
  // TODO handle errors properly
  return response.body;
}

export async function assignUsersToFolder({commit}, {folderUuid, permissions = []}) {
  const response = await axiosClient.put(`/folders/${folderUuid}/assign-users`, permissions);
  if (response.success) {
    commit(SET_FOLDER_DATA_PERMISSIONS, response.body);
  }
  // TODO handle errors properly
  return response;
}

export async function assignGroupsToFolder({commit}, {folderUuid, permissions = []}) {
  const response = await axiosClient.put(`/folders/${folderUuid}/assign-groups`, permissions);
  if (response.success) {
    commit(SET_FOLDER_DATA_PERMISSIONS, response.body);
  }
  // TODO handle errors properly
  return response;
}

export async function assignUsersToModule({commit}, {moduleUuid, permissions = []}) {
  const response = await axiosClient.put(`/modules/${moduleUuid}/assign-users`, permissions);
  if (response.success) {
    commit(SET_MODULE_DATA_PERMISSIONS, response.body);
  }
  // TODO handle errors properly
  return response;
}

export async function assignGroupsToModule({commit}, {moduleUuid, permissions = []}) {
  const response = await axiosClient.put(`/modules/${moduleUuid}/assign-groups`, permissions);
  if (response.success) {
    commit(SET_MODULE_DATA_PERMISSIONS, response.body);
  }
  // TODO handle errors properly
  return response;
}

export async function assignUsersToTable({commit}, {tableName, permissions = []}) {
  const response = await axiosClient.put(`/tables/${tableName}/assign-users`, permissions);
  if (response.success) {
    commit(SET_TABLE_DATA_PERMISSIONS, response.body);
  }
  // TODO handle errors properly
  return response;
}

export async function assignGroupsToTable({commit}, {tableName, permissions = []}) {
  const response = await axiosClient.put(`/tables/${tableName}/assign-groups`, permissions);
  if (response.success) {
    commit(SET_TABLE_DATA_PERMISSIONS, response.body);
  }
  // TODO handle errors properly
  return response;
}

export async function assignUsersToField({commit}, {fieldUuid, permissions = [], isNew}) {
  if (isNew) {
    eventBus.$emit(ON_ASSIGN_USERS_TO_FIELD_PERMISSION, {
      fieldUuid, permissions,
    });
    return {success: true};
  } else {
    const response = await axiosClient.put(`/fields/${fieldUuid}/assign-users`, permissions);
    // TODO handle errors properly
    return response;
  }

}

export async function assignGroupsToField({commit}, {fieldUuid, permissions = [], isNew}) {
  if (isNew) {
    eventBus.$emit(ON_ASSIGN_GROUPS_TO_FIELD_PERMISSION, {
      fieldUuid, permissions,
    });
    return {success: true};
  } else {
    const response = await axiosClient.put(`/fields/${fieldUuid}/assign-groups`, permissions);
    // TODO handle errors properly
    return response;
  }
}

export function showImportModal({commit}) {
  commit(SHOW_IMPORT_MODAL);
}

export function hideImportModal({commit}) {
  commit(HIDE_IMPORT_MODAL);
}

export async function showImportTableViewModal({commit, getters}, items) {
  commit(TOGGLE_TABLE_VIEW_MODAL_LOADING, true);
  const importParams = await setImportTableData({commit, getters}, {items});
  commit(SHOW_IMPORT_TABLE_VIEW_MODAL, importParams);
  commit(TOGGLE_TABLE_VIEW_MODAL_LOADING, false);
}

export async function setImportTableData({commit, getters}, {items}) {
  const fieldValues = getters.fieldValueTypes;

  const fieldDataMap = new Map();

  const textFields = [];
  const lookupFields = [];
  const dateFields = [];
  const hierarchyFields = [];
  const wholeNumberFields = [];
  const decimalNumberFields = [];
  const requiredFields = [];
  const postedStatusFields = [];
  const booleanFields = [];
  const businessKeyFields = {};
  let primaryKey = null;

  getters.fields.forEach(f => {
    if (f.dataTypeName === fieldValues.text) {
      textFields.push(f);
    }
    if (f.dataTypeName === fieldValues.lookup) {
      lookupFields.push(f);
    }
    if (f.dataTypeName === fieldValues.dateTime || f.dataTypeName === fieldValues.date) {
      dateFields.push(f);
    }
    if (f.dataTypeName === fieldValues.parentChildHierarchy) {
      hierarchyFields.push(f);
    }
    if (f.dataTypeName === fieldValues.wholeNumber) {
      wholeNumberFields.push(f);
    }
    if (f.dataTypeName === fieldValues.decimalNumber || f.dataTypeName === fieldValues.floatNumber) {
      decimalNumberFields.push(f);
    }
    if (f.dataTypeName === fieldValues.boolean) {
      booleanFields.push(f);
    }
    if (f.isRequired && !f.isInternal) {
      requiredFields.push(f);
    }
    if (f.fieldGuid === store.state.dataManagement.table.schema.postedStatusGuid) {
      postedStatusFields.push(f);
    }
    if (f.isBusinessKey) {
      businessKeyFields[f.name] = f;
    }
    if (f.isPrimaryKey) {
      primaryKey = f.key;
    }
  });

  // During import/upload we need to check if we match imported/uploaded lookup items correctly
  // Since we started use pagination for lookup items, not all the lookup options can be present
  // in the pageddata response or in the first 50 fetched lookup items
  // It's required to check the imported/uploaded lookup items among all
  // possible lookup values the related table has

  // Array of the found lookup values which not exist either in pageddata or first 50 lookup values
  const newFoundItemsList = [];

  // Go through all available lookup fields
  for (const lf of lookupFields) {
    // Array of not-existing lookup items
    const notFoundItemsList = [];

    // Go through all available table items
    for (const i of items) {
      // If lookup item doesn't exist either in pageddata or first 50 options
      // push that value in the noFoundItemsList array
      if (
        i !== null && i[lf.name] !== '<EMPTY>' &&
                lf.data && lf.data.options &&
                !lf.data.options.find(o => o.text === i[lf.name])
      ) {
        if (!isNaN(i[lf.name])) {
          notFoundItemsList.push(Number.parseFloat(i[lf.name]).toString());
        } else {
          notFoundItemsList.push(i[lf.name]);
        }
      }
    }

    if (notFoundItemsList.length > 0) {

      // Fetch all lookup items for all not found lookup items if such exist
      const requestBody = typeof notFoundItemsList[0] === 'object' && notFoundItemsList[0]['type']
        ? notFoundItemsList.map(nfi => nfi.value)
        : notFoundItemsList;

      const {body: foundFields} = await store.dispatch(
        'dataManagement/getAllLookupItemsForValues',
        {field: lf, body: requestBody},
      );

      if (foundFields && !foundFields.IsError) {
        const mdmDataTypeJSON = JSON.parse(foundFields.mdmDataTypeJSON);
        const dataTypeName = mdmDataTypeJSON.UnderlyingDataType.split('.')[1];

        let foundOptions;

        if (dataTypeName === 'Decimal') {
          const scale = mdmDataTypeJSON.Scale;
          foundOptions = [...foundFields.data.map(item => ({
            id: item.recordGuid,
            text: Number.parseFloat(item.value).toFixed(scale),
          }))];
        } else {
          foundOptions = [...foundFields.data.map(item => ({id: item.recordGuid, text: item.value}))];
        }

        const uniqueFoundField = _.uniqBy(foundOptions, 'text');

        const existingFoundList = newFoundItemsList.find(list => list.fieldGuid === lf.fieldGuid);

        // Go through list of found lookup items and update current lookup field data.options with found ones
        for (const foundI of uniqueFoundField) {
          // If lookup item doesn't exist in data.options push it there
          if (!lf.data.options.some(o => o.id === foundI.id)) {
            lf.data.options.push(foundI);
          }
        }

        // Add foundItems into newFoundItemsList array for appropriate fieldGuid
        if (existingFoundList) {
          existingFoundList.options.push(...uniqueFoundField);
        } else {
          newFoundItemsList.push({fieldGuid: lf.fieldGuid, options: uniqueFoundField});
        }
      }
    }
  }


  // for (const lf of lookupFields) {
  //   const lookupFieldFoundItems = newFoundItemsList.find(item => item.fieldGuid === lf.fieldGuid);
  //   for (const i of items) {
  //     if (i !== null && i[lf.name] !== "<EMPTY>" && lf.data && lf.data.options && !lf.data.options.find(o => o.text === i[lf.name])) {
  //       const foundValue = lookupFieldFoundItems.options.find(o => o.text === i[lf.name]);
  //       i[lf.name] = foundValue && foundValue.id;
  //     }
  //   }
  // }

  if (lookupFields.length) {
    lookupFields.forEach(f => {
      const relatedFieldDataMap = new Map();
      f.data.options.forEach(elem => {
        if (elem.text) {
          relatedFieldDataMap.set(elem.text.toString().toLowerCase(), elem);
        }
      });
      fieldDataMap.set(f.name, relatedFieldDataMap);
    });
  }

  function levenshtein(optionsValue, selectedValue) {
    // eslint-disable-next-line prefer-const
    let i, j, cost, matchedWords = [];

    if (optionsValue.length === 0) {
      return selectedValue.length;
    }
    if (selectedValue.length === 0) {
      return optionsValue.length;
    }

    for (i = 0; i <= optionsValue.length; i++) {
      matchedWords[i] = [];
      matchedWords[i][0] = i;
    }

    for (j = 0; j <= selectedValue.length; j++) {
      matchedWords[0][j] = j;
    }

    for (i = 1; i <= optionsValue.length; i++) {
      for (j = 1; j <= selectedValue.length; j++) {
        cost = optionsValue.charAt(i - 1) === selectedValue.charAt(j - 1) ? 0 : 1;
        matchedWords[i][j] = Math.min(matchedWords[i - 1][j] + 1, matchedWords[i][j - 1] + 1, matchedWords[i - 1][j - 1] + cost);

        if (i > 1 && j > 1 && optionsValue.charAt(i - 1) === selectedValue.charAt(j - 2) && optionsValue.charAt(i - 2) === selectedValue.charAt(j - 1)) {
          matchedWords[i][j] = Math.min(matchedWords[i][j], matchedWords[i - 2][j - 2] + cost);
        }
      }
    }

    return {name: optionsValue, value: matchedWords[optionsValue.length][selectedValue.length]};
  }

  function isInvalidDate(date) {
    return ['Invalid date', undefined].includes(date);
  }

  function buildTree(arr, hierarchyField) {
    const levelField = hierarchyField.data.options.hierarchyField.level;
    const primaryField = hierarchyField.data.options.hierarchyField.primary;
    const parentField = hierarchyField.data.options.hierarchyField.parent;

    const jsonData = JSON.parse(hierarchyField.dataTypeJSON);
    const minLevel = jsonData.MinimumLevelSelectable;
    const maxLevel = jsonData.MaximumLevelSelectable;

    const tree = [];
    const treeLevels = {};
    const rawArray = JSON.parse(JSON.stringify(arr)); //make copy of original
    const map = {};

    for (const item of rawArray) {
      map[item[primaryField.name]] = item;
    }

    for (const item of rawArray) {
      if (item[parentField.name]) {
        if (!map[item[parentField.name]].children) {
          map[item[parentField.name]].children = [];
        }
        map[item[parentField.name]].children = [...map[item[parentField.name]].children, item];
      } else {
        tree.push(map[item[primaryField.name]]);
      }
    }
    setLevelName(tree, 0, levelField, treeLevels, minLevel, maxLevel);

    return {tree, treeLevels};
  }

  function setLevelName(arr, level, levelField, treeLevels, minLevel, maxLevel) {
    if (!arr) {
      return;
    }

    let disabled = false;
    if (minLevel > level) {
      if (maxLevel === null) {
        disabled = true;
      }
      if (maxLevel >= level) {
        disabled = true;
      }
    }
    if (maxLevel !== null && !(minLevel === level || maxLevel >= level)) {
      disabled = true;
    }

    arr.forEach((elem) => {
      treeLevels[level] = elem[levelField.name];
      elem.level = level;
      elem.disabled = disabled;
      setLevelName(elem.children, level + 1, levelField, treeLevels, minLevel, maxLevel);
    });
  }

  function findHierarchyOption(field, value) {
    const hierarchy = field.data.options.hierarchyField;
    field = {...field, ...buildTree(field.data.options.items, field)};

    const iterator = item => {
      if (!item.disabled && item[hierarchy.display.name] === value) {
        result = item;
        return true;
      }
      return Array.isArray(item.children) && item.children.some(iterator);
    };

    let result;
    field.tree.some(iterator);
    return result;
  }

  /**
     * Add error to item and get updated result.
     * @param result
     * @param field
     * @param item
     * @param message
     * @param variant
     * @returns {*}
     */
  const addError = (result, field, item, message, variant = 'danger') => {
    item._cellVariants = {...item._cellVariants, [field.name]: variant};
    if (variant === 'danger') item.errors = {...item.errors, [field.name]: message};
    if (variant === 'warning') item.warnings = {...item.warnings, [field.name]: message};
    if (result) return {...result, ...item};
  };

  const itemIndexesWithDecimalPlacesExceeded = [];

  const itemsMapByBusinessKey = new Map();

  const getBusinessKeyForMap = (item) => {
    return Object.entries(item)
      .filter(([key, value]) => businessKeyFields[key])
      .map(([key, value]) => value)
      .join('||');
  };

  const markBusinessKeyFieldsAsErrored = (result, item) => {
    for (const fieldName in businessKeyFields) {
      const f = businessKeyFields[fieldName];
      result = addError(result, f, item, `Duplicate business key of ${item.extras ? item.extras.valueToDisplay : item[f.name]}`);
    }
    return result;
  };

  const tableItems = [];

  items.forEach((item, index) => {
    item.isVisible = true;
    item.rowIndex = index;
    let result = _.cloneDeep(item);
    const errors = [];

    if (textFields.length) {
      textFields.forEach(f => {
        const jsonData = f.dataTypeJSON ? JSON.parse(f.dataTypeJSON) : {};
        if (!jsonData.IsLineBreak && item[f.name]) {
          result[f.name] = item[f.name].toString().replace(/\n|\s\s+/g, ' ');
        } else if (jsonData.IsLineBreak && item[f.name]) {
          item[f.name] = result[f.name] = item[f.name].toString().replaceAll('{lineBreakSymbol}', '\n');
        }
      });
    }

    if (lookupFields.length) {
      let notExistedLookupData = {};
      lookupFields.forEach(f => {
        if (!item[f.name] && item[f.name] !== 0) {
          item[f.name] = '<EMPTY>';
        }
        const lookupFieldMap = fieldDataMap.get(f.name);

        const elem = item[f.name] ? lookupFieldMap.has(item[f.name].toString().toLowerCase().trim().replace(/\s\s+/g, ' ')) : undefined;
        if (!elem) {
          notExistedLookupData[f.name] = {
            matchStrings: [],
            oldValue: {},
            customClass: false,
          };
          const wordWithMatchValue = [];
          notExistedLookupData[f.name].matchStrings.push({
            id: 'other',
            text: 'Other Values',
            $isDisabled: true,
          });
          lookupFieldMap.forEach(lookupElem => {
            const word = lookupElem.text.toString();
            const matched = item[f.name] ? levenshtein(word, item[f.name]) : {name: word, value: 0};
            if (matched.value < 5) {
              wordWithMatchValue.push(matched);
            } else {
              notExistedLookupData[f.name].matchStrings.push({id: word, text: word});
            }
          });
          wordWithMatchValue
            .sort((a, b) => a.value < b.value ? 1 : a.value > b.value ? -1 : 0)
            .forEach(word => notExistedLookupData[f.name].matchStrings.unshift({
              id: word.name,
              text: word.name,
            }));

          notExistedLookupData[f.name].matchStrings.unshift({
            id: 'suggested',
            text: 'Suggested Values',
            $isDisabled: true,
          });

          notExistedLookupData[f.name].oldValue = {id: item[f.name], text: item[f.name]};

          // if (!notExistedLookupData[f.name].customClass) {
          //   notExistedLookupData[f.name].customClass = true
          // }

          item.options = notExistedLookupData;
          result = addError(result, f, item, 'Invalid Lookup Value');
        } else {
          const lookupItem = lookupFieldMap.get(item[f.name].toString().toLowerCase().trim().replace(/\s\s+/g, ' '));
          item[f.name] = lookupItem.id;
          item.extras = {
            valueToDisplay: lookupItem.text,
          };
        }
        if (item._cellVariants) {
          notExistedLookupData = item.options;
        }
        result = {...result, ...item, options: notExistedLookupData};
      });
    }
    if (requiredFields.length > 0) {
      requiredFields.forEach(f => {
        const value = item[f.name];
        const isEmpty = [null, ''].includes(value !== null ? value.toString().trim() : null);

        if (isEmpty) {
          result = addError(result, f, item, `"${f.name}" is required field`);
        }
      });
    }

    const dateFormats = {
      'DD/MM/YYYY': ['DD/MM/YYYY', 'DD/MM/YY', 'YYYY/MM/DD', 'YYYY-MM-DD', 'D/M/YY', 'DD/MMM/YYYY', 'DD-MM-YYYY', 'DD-MM-yy', 'D-M-YY', 'DD-MMM-YYYY', 'D MMM YYYY', 'MMM D YYYY'],
      'MM/DD/YYYY': ['MM/DD/YYYY', 'MM/DD/YY', 'YYYY/MM/DD', 'YYYY-MM-DD', 'M/D/YY', 'MMM/DD/YYYY', 'MM-DD-YYYY', 'MM-DD-yy', 'M-D-YY', 'MMM-DD-YYYY', 'D MMM YYYY', 'MMM D YYYY'],
      'YYYY/MM/DD': ['YYYY/MM/DD', 'YYYY-MM-DD', 'YY/MM/DD', 'YY/M/D', 'YY-MM-DD', 'YY-M-D', 'D MMM YYYY', 'MMM D YYYY'],
    };

    const validateAndGetFormattedDate = (date, dateFormat, isDatetime) => {
      let formattedDate;

      let dateTimeFormat;
      if (isDatetime) {
        dateTimeFormat = Object.keys(dateFormats).find(key => dateFormat.indexOf(key) > -1);
      }

      const isValidDate = dateFormats[dateTimeFormat || dateFormat].some(format => {
        let momentDate = moment(date, `${format}${isDatetime ? ' HH:mm:ss' : ''}`, true);
        if (momentDate.isValid()) {
          if (typeof date === 'object') {
            momentDate = momentDate.utcOffset('UTC-00:00');
          }
          formattedDate = momentDate.format(dateFormat);
          return true;
        }
        return false;
      });

      return {isValidDate, formattedDate};
    };


    if (dateFields.length > 0) {
      dateFields.forEach(f => {

        if (!item[f.name]) return false;

        const isDateTime = f.dataTypeName === fieldValues.dateTime;

        // Get date format
        const selectedFormat = JSON.parse(f.dataTypeJSON).FormatString;
        const dateFormat = isDateTime ? selectedFormat ? `${selectedFormat} HH:mm:ss` : 'YYYY/MM/DD HH:mm:ss' : selectedFormat ? selectedFormat : 'YYYY/MM/DD';

        const {isValidDate, formattedDate} = validateAndGetFormattedDate(item[f.name], dateFormat, isDateTime);

        if (isValidDate) {

          const parseDate = moment(formattedDate, dateFormat).valueOf();

          let convertedDate;
          if (!isNaN(parseDate)) {
            convertedDate = isDateTime ?
              Vue.filter('toDatetime')(parseDate, dateFormat) :
              Vue.filter('toDate')(parseDate, dateFormat);
          } else {
            convertedDate = isDateTime ?
              Vue.filter('toDatetime')(moment(item[f.name], 'DD/MM/YYYY HH:mm:ss').toDate(), dateFormat) :
              Vue.filter('toDate')(moment(item[f.name], 'DD/MM/YYYY').toDate(), dateFormat);
          }
          if (!result._rowVariant) {
            result = isInvalidDate(convertedDate) && result[f.name] ? {
              ...result,
              _rowVariant: 'danger',
            } : result;
          }
          if (!isInvalidDate(convertedDate)) {
            item[f.name] = result[f.name] = convertedDate;
          } else if (item[f.name]) {
            result = addError(result, f, item, `Date should be "${dateFormat}" format`);
          }
        } else {
          result = addError(result, f, item, `Date should be "${dateFormat}" format`);
        }
      });
    }
    if (hierarchyFields.length > 0) {
      hierarchyFields.forEach(f => {
        const chosenOption = findHierarchyOption(f, item[f.name]);

        if (!result._rowVariant) {
          result = !chosenOption && item[f.name] ? {...result, _rowVariant: 'danger'} : result;
        }
        if (!chosenOption && item[f.name]) {
          errors.push(`The value for the "${f.name}" isn't valid, please update the field with correct value`);
        }
      });
    }
    if (booleanFields.length > 0) {
      booleanFields.forEach(f => {
        if (!['TRUE', 'FALSE', '1', '0', '', 'NULL'].includes(`${item[f.name]}`.toUpperCase()) || (f.isRequired && ['', null].includes(item[f.name]))) {
          result = addError(result, f, item, 'Value should be boolean type');
        }
      });
    }
    if (wholeNumberFields.length > 0) {
      wholeNumberFields.forEach(f => {
        if (!item[f.name] && item[f.name] !== 0) {
          return item[f.name];
        }

        result[f.name] = item[f.name].toString().replace(/,/g, '');

        if (isNaN(result[f.name])) {
          result = addError(result, f, item, 'Incorrect Format');
        } else if (Number.isFloat(result[f.name])) {
          result = addError(result, f, item, 'Value must be whole number, decimal entered');
        } else {
          result[f.name] = Math.round(result[f.name]);
        }
      });
    }

    if (decimalNumberFields.length > 0) {
      decimalNumberFields.forEach(f => {
        if (item[f.name]) {

          const jsonData = JSON.parse(f.dataTypeJSON);
          const scale = jsonData.Scale;
          const precision = jsonData.Precision;
          const isPercentage = jsonData.IsPercentage;

          let value = item[f.name].toString().replace(/,/g, '');
          const floatValue = parseFloat(value);

          value = (isPercentage && !value.includes('%') ? floatValue * 100 : floatValue);
          value = parseFloat(value).toString();

          const [numberPrecision = '', numberDecimal = ''] = value.split('.');

          let trimDecimals = false;
          if (numberDecimal.length > scale) {

            if (jsonData.ApplyRounding) {
              trimDecimals = true;
              if (!itemIndexesWithDecimalPlacesExceeded.includes(index)) {
                itemIndexesWithDecimalPlacesExceeded.push(index);
              }
              result = addError(result, f, item, `this value was formatted to ${numberDecimal.length} decimal places, which exceeds the allowed number of ${scale} decimal places, as per the table set up. This has been automatically trimmed to ${scale} decimal places`, 'warning');
            } else {
              result = addError(result, f, item, `this value exceeds the allowed number of ${scale} decimal places as per the table set up`);
            }
          } else if (numberPrecision.length > precision) {
            result = addError(result, f, item, 'Number length more than precision');
          } else if (isNaN(value)) {
            result = addError(result, f, item, 'Incorrect Format');
            value = item[f.name].toString();
          }

          item = result;

          result[f.name] = trimDecimals ? parseFloat(value).toFixed(scale) : parseFloat(value);
        }
      });
    }
    if (postedStatusFields.length > 0) {
      postedStatusFields.forEach(f => {
        if (!['Pending', 'Posted'].includes(item[f.name])) {
          result = addError(result, f, item, 'Value should be \'Pending\' or \'Posted\'');
        }

        // if (item[f.name] === 'Posted') {
        //   result = addError(result, f, item, `Unable to update records that are Posted`);
        // }
      });
    }
    if (errors.length > 0) {
      result.errors = [...errors];
    }

    const businessKeyForMap = getBusinessKeyForMap(result);
    if (itemsMapByBusinessKey.has(businessKeyForMap)) {
      // Detected duplicates
      const [index, firstItem] = itemsMapByBusinessKey.get(businessKeyForMap);
      tableItems[index] = markBusinessKeyFieldsAsErrored(firstItem, firstItem);
      tableItems[index].options = tableItems[index].options || {};
      result = markBusinessKeyFieldsAsErrored(result, result);
    } else {
      itemsMapByBusinessKey.set(businessKeyForMap, [index, result]);
    }

    tableItems.push(result);
  });

  return {
    tableItems,
    fieldDataMap,
    itemCountWithDecimalPlacesExceeded: itemIndexesWithDecimalPlacesExceeded.length,
  };
}

export async function updateImportTableViewModalItems({commit}, params) {
  commit(UPDATE_IMPORT_TABLE_VIEW_MODAL_ITEMS, params);
}

export async function updateImportReview({commit}, params) {
  commit(UPDATE_IMPORT_REVIEW, params);
}

export async function updateImportLookupOptions({commit}, {field, option}) {
  commit(UPDATE_IMPORT_LOOKUP_OPTION, {field, option});
}

export function hideImportTableViewModal({commit}) {
  commit(HIDE_IMPORT_TABLE_VIEW_MODAL);
}

export async function getTodoListData({commit}) {
  commit(TOGGLE_TODO_LIST_TABLE_LOADING, true);
  const {success, body} = await axiosClient.get('/api/ToDoList');
  if (success) {
    commit(GET_TABLE_DATA, body);
  }
  commit(TOGGLE_TODO_LIST_TABLE_LOADING, false);
}

export async function getTodoUserList({commit}) {
  const {success, body} = await axiosClient.get('api/ToDoList/ToDoListUsers');
  if (success) {
    commit(GET_TODO_USER_LIST, body);
  }
}

export async function getTodoListByUser({commit}, userGuid) {
  commit(TOGGLE_TODO_LIST_TABLE_LOADING, true);
  const {success, body} = await axiosClient.get(`api/ToDoList/${userGuid}`);
  if (success) {
    commit(GET_TABLE_DATA, body);
  }
  commit(TOGGLE_TODO_LIST_TABLE_LOADING, false);
}

export async function getPermissionsByObjectId({commit}, objectId) {
  const {success, body} = await axiosClient.get(`/api/Permission/object/${objectId}`);
  if (success) {
    commit(GET_PERMISSIONS_BY_OBJECT, body);
  }
}

export async function getPermissionsByUserGuid({commit}, userGuid) {
  const {success, body} = await axiosClient.get(`/api/Permission/${userGuid}`);
  if (success) {
    return body;
  }
}

export async function getUserPermissions({commit}, userGuid) {
  return await axiosClient.get(`/api/SystemInfo/permissions/${userGuid}`);
}

export async function updatePermission({commit}, data) {
  return await axiosClient.put('/api/Permission', data);
}

export async function createPermission({commit}, data) {
  return await axiosClient.post('/api/Permission', data);
}

export async function deletePermission({commit}, permGuid) {
  return await axiosClient.delete(`/api/Permission/${permGuid}`);
}

export function showDataManagementModal({commit}) {
  commit(TOGGLE_DATA_MANAGEMENT_MODAL, true);
  commit(SHOW_DATA_MANAGEMENT_MODAL, true);
  commit(TOGGLE_DATA_MANAGEMENT_MODAL, false);
}

export function hideDataManagementModal({commit}) {
  commit(HIDE_DATA_MANAGEMENT_MODAL);
}

export async function getHistoryTable({commit, getters, state, rootState}, params) {
  commit(SET_TABLE_VIEW_LOADING, true);

  const table = await axiosClient.get(`api/entity/${params.id}`);
  const tableData = await axiosClient.get(`/api/Entity/${params.id}/data/history`);
  const fields = await axiosClient.get(`api/entity/${params.id}/fields`);
  const folder = await axiosClient.get(`api/folder/${table.body.folderGuid}`);
  const fieldsData = await fieldSetter(
    {commit, getters, state, rootState},
    {fields: fields.body, table: table.body, items: {}});
  const data = {
    ...table.body,
    folder: folder.body,
    fields: fieldsData.entityFields,
    data: tableData.body,
    total: tableData.body.length,
    primaryColumn: fieldsData.primaryColumn,
  };


  commit(SET_TABLE_VIEW_SCHEMA, {...data, ...{page: params.page}});

  commit(SET_TABLE_VIEW_LOADING, false);
}

export async function getExportPagedData({state, commit, getters, rootState}, params) {
  const res = await axiosClient.post(`api/entity/${params.id}/pageddata`, params);
  const fieldsData = await fieldSetter(
    {commit, getters, state, rootState},
    {
      fields: state.table.schema.fields,
      table: state.table,
      items: res.body,
      allField: getters.getAllFields,
    });

  const data = {
    ...state.tableData.data,
    folder: getters.getCurrentFolder,
    fields: fieldsData.entityFields,
    data: res.body.Records || [],
    total: res.body.TotalRecords || 0,
    toggleColumns: state.table.schema.toggleColumns || false,
    primaryColumn: fieldsData.primaryColumn,
  };

  commit(SET_TABLE_VIEW_SCHEMA, {...data, ...{page: params.page}});

  return res;
}

export function updateTableItems({commit}, params) {
  commit(UPDATE_TABLE_ITEMS, params);
}

export function updatePaginationParams({commit}, params) {
  commit(UPDATE_PAGINATION_PARAMS, params);
}

export async function createPowerAppsEntity({commit}, params) {
  return await axiosClient.post('/api/entity/powerapp', params);
}

export async function updatePowerAppsEntity({commit}, params) {
  return await axiosClient.put('/api/entity/powerapp', params);
}

export async function getPowerAppsEntity({commit}, entityGuid) {
  const response = await axiosClient.get(`/api/entity/powerapp/${entityGuid}`);
  if (response.success) {
    commit(SET_POWER_APPS_ENTITY, response.body);
  }

  return response;
}

export async function upsertPowerBiReportEntity({commit}, params) {
  const response = await axiosClient.post(`/api/entity/powerBi/${params.entityGuid}`, params);
  if (response.success) {
    commit(SET_POWER_APPS_ENTITY, response.body);
  }

  return response;
}

export async function getPowerBiReportEntity({commit}, entityGuid) {
  const response = await axiosClient.get(`/api/entity/powerBi/${entityGuid}`);
  if (response.success) {
    commit(SET_POWER_BI_REPORT_ENTITY, response.body);
  }

  return response;
}

export async function getTableItems({commit}, entityGuid) {
  const {success, body} = await axiosClient.get(`/api/entity/${entityGuid}/data`);

  if (success) {
    return body;
  }

  return [];
}

export async function saveToggleColumns({commit}, {entityGuid, columns}) {
  commit(SET_TABLE_TOGGLE_COLUMNS, columns);
}

export async function createOrUpdateMDMView({commit}, view) {
  const isCreate = !view.viewGuid;
  const viewTmp = {
    ...view,
  };
  delete viewTmp.isSelected;
  const {success, errors, body} = await axiosClient.post('/api/view/upsertview', viewTmp);
  view = {
    ...body,
    isSelected: true,
  };
  if (isCreate) {
    commit(ADD_MDM_VIEW, view);
    commit(SELECT_MDM_VIEW, view.viewGuid);
  } else {
    commit(UPDATE_MDM_VIEW, view);
  }
  return {success, errors, view};
}

export async function makeMDMViewDefault({commit}, view) {
  const response = await axiosClient.post(`/api/view/makedefault/${view.viewGuid}/${view.entityGuid}`);
  commit(MDM_VIEW_MARK_DEFAULT, response.body.viewDto);
  return response;
}

export async function deleteMDMView({commit}, guid) {
  const response = await axiosClient.delete(`/api/view/${guid}`);
  if (response.success) {
    commit(DELETE_MDM_VIEW, guid);
  }
  return response;
}

export function showTodoListModal({commit}, data = null) {
  commit(SHOW_TODO_LIST_MODAL, data);
}

export function hideTodoListModal({commit}, data = null) {
  commit(HIDE_TODO_LIST_MODAL, {data});
}

export async function getPagedDataLookupValueItems({commit}, data = null) {
  commit(SET_PAGEDDATA_LOOKUP_VALUES_LOADING, true);
  
  const {field, query, isValidationRules = false} = data;
  const fieldDataJSON = typeof field.dataTypeJSON !== 'string'
    ? field.dataTypeJSON
    : JSON.parse(field.dataTypeJSON);

  const relationalTableId = field.relationalTableId;
  const relationalFieldId = field.relationalFieldId;
  const fieldToDisplayGuid = fieldDataJSON.FieldToDisplayGuid;

  let textFilters = [];

  const isQueryGuid = isGuid(query);

  if (query) {
    let fieldGuid = relationalFieldId;
    if(isQueryGuid) {
      const {body} = await axiosClient.get(`api/entity/${relationalTableId}/fields`);
      fieldGuid = body.find(el => el.isPrimaryKey).fieldGuid;
    }
    textFilters = [{
      fieldGuid: isValidationRules ? fieldGuid : relationalFieldId,
      filterOperator: 'contains',
      value: query,
    }];
  }

  const body = {
    sortCriteria: [{FieldNameOrGuid: relationalFieldId, ascending: true}],
    filters: query ? {textFilters} : {},
    id: field.entityGuid,
    pageNumber: 1,
    pageSize:  50,
    groupBy: null,
    subGroupBy: null,
  };

  const response = await axiosClient.post(`/api/entity/${relationalTableId}/${fieldToDisplayGuid}/GetPagedDataLookupValueItems`, body);

  commit(SET_PAGEDDATA_LOOKUP_VALUES_LOADING, false);
  return response;
}

export function addSelectedValueToDefaultFields({commit}, payload)  {
  commit(ADD_SELECTED_VALUE_TO_DEFAULT_FIELDS, payload);
}

export async function getAllLookupItemsForValues(context, data) {
  const {field, body} = data;

  const fieldDataJSON = JSON.parse(field.dataTypeJSON);
  const relationalTableId = field.relationalTableId;
  const fieldToDisplayGuid = fieldDataJSON.FieldToDisplayGuid;

  return await axiosClient.post(`/api/entity/${relationalTableId}/${fieldToDisplayGuid}/GetAllLookupItemsForValues`, body);
}

export async function saveFieldsOrder({commit}, data = []) {
  const {success} = await axiosClient.post('/api/field/UpdateFieldOrder', data);
  commit(SET_FIELD_ITEM_CALCULATION_LOADING_STATE, false);
  return success;
}

export async function getOrchestration({commit}) {
  commit(SET_ORCHESTRATION_LOADING, false);
  const response = await axiosClient.get('/api/orchestration');
  if (response.success) {
    commit(SET_ORCHESTRATION, {data: response.body});
    commit(SET_ORCHESTRATION_LOADING, true);
  }
  return response;
}

export const openContextMenu = ({commit}, id) => {
  commit(OPEN_CONTEXT_MENU, id);
};

export const closeContextMenu = ({commit}) => {
  commit(CLOSE_CONTEXT_MENU);
};
export const updateFuzzyList = ({commit}, payload) => {
  commit(UPDATE_FUZZY_LIST, payload);
};

export const createFuzzyConfig = ({commit}) => {
  commit(CREATE_FUZZY_CONFIG);
};
export const removeElementFromFuzzyList = ({commit}, id) => {
  commit(REMOVE_ELEMENT_FROM_FUZZY_LIST, id);
};

export const addKeysForFuzzyConfigItems = ({commit}) => {
  commit(ADD_KEYS_FOR_FUZZY_CONFIG_ITEMS);
};

export const removeConfigIfFuzzyDidNotSelected = ({commit}) => {
  commit(REMOVE_CONFIG_IF_FUZZY_DID_NOT_SELECTED);
};

export const transformFuzzyConfig = ({commit}, isOpen) => {
  commit(TRANSFORM_FUZZY_CONFIG, isOpen);
};

export const resetDefaultOptions = ({commit}, payload) => {
  commit(RESET_DEFAULT_OPTIONS, payload);
};

export const resetTableData = ({commit}) => {
  commit(RESET_TABLE_DATA);
};

/**
 * Send the updated calculation to the backend.
 * @param {uuid} fieldGuid 
 * @param {Object} calculationData
 * @returns API response.
 */
export async function updateCalculation ({commit}, {id, calculation}) {
  const data = {
    'FieldGuid': id,
    'Calculation': calculation,
  };
  const response = await axiosClient.put('/api/field/UpdateCalculation', data);
  if (response.success){
    /* Update the Field's definition. */

  }
  return response;
};

export const updateCalculations = ({commit}, payload) => {
  commit(UPDATE_CALCULATIONS, payload);
};

export const updateTableFieldsIsCalculationState = ({commit}, payload) => {
  commit(UPDATE_TABLE_FIELD_IS_CALCULATED_STATE, payload);
};

export const updateFieldItemCalculationLoadingState = ({commit}, payload) => {
  commit(SET_FIELD_ITEM_CALCULATION_LOADING_STATE, payload);
};

export const changeTableFieldsOption = ({commit, state}, payload) => {
  const {content, field} = payload;
  const data = state.table.schema.fields.map(f => {
    if(f.fieldGuid === field.fieldGuid){
      f.data.options.push(content);     
    }
    return f;
  });
  commit(SET_TABLE_FIELDS, data);
};

export const updateLookupOptions = ({commit}, payload) => {
  commit(UPDATE_LOOKUP_OPTION, payload);
};

/* Actions for the view upload history modal */
export const updateUploadHistoryLoading = ({commit}) => {
  commit(SET_UPLOAD_HISTORY_LOADING, true);
};

export const getUploadHistoryData = async ({commit}, entityGuids) => {
  const {success, body} = await axiosClient.post('/api/entity/UploadHistory', entityGuids);

  if (success && body.length > 0) {
    body.forEach(item => {
      // Add this property to enable hide/show of details drawer with full upload history 
      item._showDetails = false;
  
      // Format dates to a more readable format
      if (item.StartTime) {
        item.StartTime = moment(item.StartTime).format('YYYY-MM-DD HH:mm:ss.SSS');
      }
      if (item.EndTime) {
        item.EndTime = moment(item.EndTime).format('YYYY-MM-DD HH:mm:ss.SSS');
      }
      if (entityGuids.length === 1) {
        delete item.TableName;
      }
    });
  
    commit(SET_UPLOAD_HISTORY_DATA, body);
  } else {
    commit(SET_UPLOAD_HISTORY_DATA, []);
  }
  commit(SET_UPLOAD_HISTORY_LOADING, false);
  commit(UPDATE_UPLOAD_HISTORY_PAGINATION, {currentPage: 1, perPage: 10});
};

export const getFullDataForOneUpload = async ({commit}, uploadId) => {
  commit(SET_UPLOAD_HISTORY_LOADING, true);
  const {success, body} = await axiosClient.get(`/api/entity/UploadHistory/${uploadId}`); 

  if (success) {

    // Format the errors to make more readable
    if (body['Errors'].length > 0) {
      const rawError = body.Errors[0];
      const unescaped = rawError
        .replace(/\\r\\n/g, '\n') // Replace \r\n with actual newlines
        .replace(/\\"/g, '"')     // Replace \" with actual double quotes
        .replace(/\\\\/g, '\\');  // Replace \\ with a single backslash
      try {
        const parsedError = JSON.parse(unescaped);
        const formattedError = JSON.stringify(parsedError, null, 2);
        body['Errors'] = formattedError;
      } catch {
        body['Errors'] = unescaped;
      }
    }
    
    commit(UPDATE_FULL_UPLOAD_DATA, body);
  } else {
    commit(UPDATE_FULL_UPLOAD_DATA, {});
  }
  commit(SET_UPLOAD_HISTORY_LOADING, false);
};